import { Navigate } from "react-router-dom";

const AdminRoute = ({ component: Component, ...rest }) => {
  // * Check the user is Admin only that user can access the Admin Routes.
  const token = localStorage.getItem("ts-auth-token");
  const roleLocal = localStorage.getItem("role");
  const roleType = localStorage.getItem("roleType");

  if (token) {
    if (roleLocal === "Admin" && rest?.role === "Admin") {
      return (
        <>
          <Component {...rest} />
        </>
      );
    } else if (rest?.role !== "Admin" && roleType === "Admin") {
      return (
        <>
          <Component {...rest} />
        </>
      );
    } else {
      return <>{/* <PageNotFound /> */}</>;
    }
  } else {
    return <Navigate to="/" />;
  }
};

export default AdminRoute;
